/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import loadCurrentPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadCurrentPromotions";
import loadPromotions from "@insite/client-framework/Store/Data/Promotions/Handlers/LoadPromotions";
import {
    chain,
    LoadCart,
    LoadPromotions,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/Cart/Handlers/RemoveCartLine";
import loadCart from "@insite/client-framework/Store/Pages/RequisitionConfirmation/Handlers/LoadCart";

export const XngPopulateApiParameter: any = (props: any) => {
    props.apiParameter = {
        cartLineId: props.parameter.cartLineId,
        cartId: props.parameter.cartId || API_URL_CURRENT_FRAGMENT,
    };
};

export const XngLoadCart: any = (props: any) => {
    if (props.apiParameter.cartId !== API_URL_CURRENT_FRAGMENT) {
        props.dispatch(loadCart({ cartId: props.apiParameter.cartId }));
    } else {
        props.dispatch(loadCurrentCart({ getPromotions: true }));
    }
};

export const XngLoadPromotions: any = (props: any) => {
    if (props.apiParameter.cartId !== API_URL_CURRENT_FRAGMENT) {
        props.dispatch(loadPromotions({ cartId: props.apiParameter.cartId }));
    } else {
        props.dispatch(loadCurrentPromotions());
    }
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, LoadCart, XngLoadCart);
replaceInChain(chain, LoadPromotions, XngLoadPromotions);
